import React from "react";

const experienceContent = [
  {
    year: "2021 - Present",
    position: " Web Developer & Programmer",
    compnayName: "Stubnet Pvt Ltd",
    details: `Currently working as React JS & Native Programmer and developer at stubnet with Rest API creating with core PHP.`,
  },
  {
    year: "2017 - 2021",
    position: " Network Engineer & CEO",
    compnayName: "Reliant Techno Networking",
    details: `Working as Network Administrator and CEO of the company in this period. With supporting Optical fiber team,
    Wireless network team and Server setuping and maintainance team as a leader.`,
  },
  {
    year: "2015 - 2017",
    position: "Freelancer",
    compnayName: "Core PHP & SCSS",
    details: `Freelancing jobs done at this time period for multiple outsourcing companies.`,
  },
];

const Experience = () => {
  return (
    <ul>
      {experienceContent.map((val, i) => (
        <li key={i}>
          <div className="icon">
            <i className="fa fa-briefcase"></i>
          </div>
          <span className="time open-sans-font text-uppercase">{val.year}</span>
          <h5 className="poppins-font text-uppercase">
            {val.position}
            <span className="place open-sans-font">{val.compnayName}</span>
          </h5>
          <p className="open-sans-font">{val.details}</p>
        </li>
      ))}
    </ul>
  );
};

export default Experience;
